import reducer, {
    selectFormStatuses,
} from './formStatuses.slice'

export {
    selectFormStatuses,
}

export default reducer
